export default __webpack_public_path__ + "static/media/Untitled2.164cc1cc.svg";